module.exports = __webpack_public_path__ + "static/media/16-6.f26e8f9e.mp3";